import {createContext} from "react";

import type {JsonPath, JsonValue} from "./types.ts";

type CoeditorAPI = Readonly<{
    setDocumentTitle(documentTitle: string): void;
    setTemplateName(templateName: string): void;
    setConfigOverride(rawConfigYAML: string): void;
    requestTemplateCompletion(options?: {
        configName?: string;
        templateName?: string;
    }): Promise<void>;
    requestNewValue(at: JsonPath, instructions: string): Promise<void>;
    replaceValue(at: JsonPath, newValue: JsonValue): void;
    deleteValue(at: JsonPath): void;
    copyDocument(documentId: string, snapshotId: string): Promise<string>;
    reset(): void;
}>;

export const CoeditingAPIContext = createContext<CoeditorAPI>({
    setDocumentTitle() {},
    setTemplateName() {},
    setConfigOverride() {},
    async requestTemplateCompletion() {},
    async requestNewValue() {},
    replaceValue() {},
    deleteValue() {},
    copyDocument() {
        return Promise.resolve("");
    },
    reset() {},
});
